import { render, staticRenderFns } from "./LostItemCUDialog.vue?vue&type=template&id=ef5f8b00&scoped=true"
import script from "./LostItemCUDialog.vue?vue&type=script&lang=js"
export * from "./LostItemCUDialog.vue?vue&type=script&lang=js"
import style0 from "./LostItemCUDialog.vue?vue&type=style&index=0&id=ef5f8b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5f8b00",
  null
  
)

export default component.exports